import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  card: {
    boxShadow: "0 1px 3px 1px rgba(0,0,0,0.045)",
    borderColor: "rgba(0,0,0,0.1)",
  },
  list: {
    listStyleType: "none",
    margin: 0,
    padding: 0,

    "& > *": {
      display: "flex",
      alignItems: "baseline",
    },
  },
}));
